import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TopBanner } from './components/TopBanner';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { RealProof } from './components/RealProof';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '2292460911162237');
    f.fbq('track', 'PageView');
  }, []);
  const testimonials = [{
    name: 'Valentina S.',
    location: 'Tucumán',
    text: 'Hice mis primeros sahumerios el fin de semana siguiente de comprarlo. El miércoles ya tenía 5 pedidos por WhatsApp. No lo puedo creer.'
  }, {
    name: 'Romina G.',
    location: 'GBA Sur',
    role: 'Emprendedora desde casa',
    text: 'Siempre quise vender algo artesanal pero no sabía cómo hacer la masa sin que se rompa. El Tomo 1 me explicó todo en detalle y ahora mis sahumerios duran perfectos.'
  }, {
    name: 'Paola M.',
    location: 'Córdoba',
    text: 'Los sahumerios zodiacales fueron un golazo. Mis clientas me los piden por signo. Cada semana tengo pedidos nuevos.'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <TopBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials testimonials={testimonials} data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Bonuses data-id="element-6" />
      <RealProof data-id="element-7" />
      <Pricing data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <CostOfInaction data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
      <WhatsAppButton data-id="element-14" />
    </div>;
}